var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Sidebar/SidebarNavLabel.vue?vue&type=template&id=3716e1c6&
// module id = null
// module chunks = 